// extracted by mini-css-extract-plugin
export default {"container":"SM-z","topReviewHeading":"TM-z","criticalReview":"UM-z","favorableReview":"VM-z","vsSeparator":"WM-z"};